export const administrationRolesMessages = {
  en: {
    titleAdd: 'Add role',
    titleEdit: 'Edit role',
    titleCopy: 'Copy role',
    addRoleButton: 'Add role',
    actionColumnTitle: 'Action',
    form: {
      copy: 'copy',
      cancel: 'Cancel',
      save: 'Save',
      fields: {
        name: 'Role name',
        description: 'Description',
        policies: 'Policies',
      },
      validation: {
        nameRequired: 'Role name is required',
        pattern: '"name" fails to match the required pattern: {pattern}',
      },
    },
    deleteRoleConfirmDialog: {
      btnSecondaryConfirm: 'Cancel',
      btnConfirm: 'Delete',
      header: 'Role will be removed',
      subHeader: 'Are you sure you want to remove the role?',
    },
    request: {
      resourceConflict: 'Role with same name already exists',
    },
  },
};
